<template>
    <div v-if="isVisible" class="cl-cont">
        <CollabArtists
            v-if="!artistSelected"
            :onSelectArtist="onSelectArtist"
            :collabs="collabs"
            :onGenreSelected="onGenreSelected"
        />
        <ArtistInfo
            v-if="artistSelected"
            :onCloseArtist="onCloseArtist"
            :collab="selectedArtist"
            :onReceiveDemo="onReceiveDemo"
            :currentSong="currentSong"
        />
    </div>
</template>
<script>
    import CollabArtists from "./CollabArtists";
    import ArtistInfo from "./ArtistInfo";
    import { db } from "../config/firebaseInit";
    import { environment } from "../constants";
    export default {
      name: 'CollabLabHome',
      components: {
        ArtistInfo,
        CollabArtists
      },
      props: {
        isVisible: {
          type: Boolean,
          default: false
        },
        onReceiveDemo: {
          type: Function
        },
        currentSong: {
          type: Object
        }
      },
      data() {
        return {
          artistSelected: false,
          selectedArtist: {},
          collabs: []
        }
      },
      methods: {
        onSelectArtist: function(collabId) {
          let selectedArtist = this.collabs.filter((collab) => {
            return collab.id === collabId;
          });
          this.selectedArtist = selectedArtist[0];
          this.artistSelected = true;
        },

        onCloseArtist: function() {
          this.artistSelected = false;
        },

        fetchCollabs() {
          let collabList = [];
          db.collection(`${environment}-collab`)
            .orderBy('uploadDate', 'desc')
            .get().then((collabs) => {
            collabs.forEach((collab) => {
              collabList.push({ ...collab.data(), id: collab.id });
            });
            this.collabs = collabList;
          }).catch((error) => {
            console.log('could not get the collab list: ', error);
          });
        },
        onGenreSelected(genre) {
          if (genre === 'All Music Genres') {
            this.fetchCollabs();
            return;
          }
            let collabList = [];
            db.collection(`${environment}-collab`)
              .orderBy('uploadDate', 'desc')
              .where('genre', '==', genre)
              .get().then((result) => {
              result.forEach((result) => {
                collabList.push({ ...result.data(), id: result.id });
              });
              this.collabs = collabList;
            }).catch((error) => {
              console.log(`could not fetch collabs under genre ${genre}: `, error);
            });
        }
      },
      created() {
        this.fetchCollabs();
      }
    }
</script>
<style lang="scss">
    .cl-cont {
        padding-bottom: 8%;
    }
</style>